import ApiKeysMangement from "app/components/ApiKeysManagement";
import ediaryApiKeysService from "app/services/ediaryApiKeys.service";

class EDiaryApiKeyManagement extends ApiKeysMangement {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        await super.componentDidMount();
        this.setState({
            header: "Manage API Keys",
        });
    }

    //overridden by the parent component
    async fetchAllApiKeys() {
        return await ediaryApiKeysService.getAllApiKeys();
    }

    async createApiKey(apiKey) {
        return await ediaryApiKeysService.createApiKey(apiKey);
    }

    async updateApiKey(apiKey) {
        return await ediaryApiKeysService.updateApiKey(apiKey);
    }

    async deleteApiKey(apiKeyId) {
        return await ediaryApiKeysService.deleteApiKey(apiKeyId);
    }
}

export default EDiaryApiKeyManagement;